import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Icon, useTheme } from "@app/ui";
import { useLang, useT } from "../i18n.js";
import { BrandMark } from "../components/BrandMark.js";
import "../landing/landing.css";

/**
 * Language + theme switches for the signed-out surface. Auth pages are the one
 * place a visitor can't reach the in-app header controls, so they get their own.
 */
export function AuthControls() {
  const { theme, toggle } = useTheme();
  const { lang, setLang } = useLang();
  const t = useT();
  return (
    <div className="auth-controls">
      <Button
        variant="subtle"
        size="sm"
        aria-label={t("common.language")}
        onClick={() => setLang(lang === "en" ? "tr" : "en")}
      >
        {lang === "en" ? "TR" : "EN"}
      </Button>
      <Button
        variant="subtle"
        size="sm"
        aria-label={t("common.toggleTheme")}
        icon={<Icon name={theme === "light" ? "moon" : "sun"} />}
        onClick={toggle}
      />
    </div>
  );
}

/**
 * Shared chrome for the standalone auth pages (verify-email, accept-invite):
 * brand bar on top, a single centered card, standards footer. Theme-aware —
 * everything reads the --az-* tokens.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="auth-shell">
      <header className="auth-shell-bar">
        <Link to="/" className="auth-shell-logo">
          <BrandMark size={19} className="brand-mark" />
          IDPP<span>.net</span>
        </Link>
        <AuthControls />
      </header>
      <main className="auth-shell-main">
        <Card className="auth-shell-card">{children}</Card>
      </main>
      <footer className="auth-shell-foot">ESPR 2024/1781 · EN 1821x · GS1 DIGITAL LINK</footer>
    </div>
  );
}
